const tables = [
  {
    name: "Name",
  },
  {
    name: "Action",
  },
];

export default tables;
